import type { ReactNode } from 'react'
import { Lock } from 'lucide-react'

import { brand } from '@/brand/brand'
import { Button } from '@/components/ui/button'

/**
 * The branded "this step runs live for clients" panel. All AI is locked in the public
 * demo (zero server keys); every AI trigger renders THIS with a canned sample + CTA.
 * Copy is pure brand data (brand.copy.locked*), so it rebrands as a data swap.
 */
export function LockedStep({
  feature,
  sample,
}: {
  feature?: string
  sample?: ReactNode
}) {
  const c = brand.copy
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-start gap-3">
        <span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Lock className="size-4" />
        </span>
        <div className="space-y-1">
          <h2 className="text-lg font-semibold leading-tight">{c.lockedTitle}</h2>
          <p className="text-sm text-muted-foreground">{c.lockedBody}</p>
        </div>
      </div>

      {sample && (
        <div className="overflow-hidden rounded-lg border bg-muted/40">
          <div className="border-b bg-muted/60 px-3 py-1.5 text-xs font-medium text-muted-foreground">
            Sample output{feature ? ` — ${feature.replace(/_/g, ' ')}` : ''}
          </div>
          <div className="p-2">{sample}</div>
        </div>
      )}

      <div className="flex justify-end">
        <a href={c.lockedCta.href} target="_blank" rel="noreferrer">
          <Button>{c.lockedCta.label}</Button>
        </a>
      </div>
    </div>
  )
}
